var map = {
	"./logo_aircraft-mechanic.svg": 90139,
	"./logo_commercial-crew.svg": 45383,
	"./logo_drone-operator.svg": 78,
	"./logo_engineering.svg": 6628,
	"./logo_professional-pilot.svg": 5389,
	"./logo_recreational-pilot.svg": 8213,
	"./logo_traffic-controller.svg": 25702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72370;